module.exports = __webpack_public_path__ + "static/media/2030.a7bb93fd.svg";